var render = function render(){var _vm=this,_c=_vm._self._c;return _c('datePicker',{attrs:{"id":_vm.id,"type":_vm.type,"clearable":true,"format":"YYYY-MM-DD HH:mm:ss","display-format":_vm.displayFormat,"value":_vm.insideValue,"placeholder":_vm.placeholder},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }